import { render, staticRenderFns } from "./FullWidthNotice.vue?vue&type=template&id=095eaf68&scoped=true"
import script from "./FullWidthNotice.vue?vue&type=script&lang=js"
export * from "./FullWidthNotice.vue?vue&type=script&lang=js"
import style0 from "./FullWidthNotice.vue?vue&type=style&index=0&id=095eaf68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095eaf68",
  null
  
)

export default component.exports